import moment from 'moment'

export function filterRowsBySearch(params) {
	const { filteredRows, searchText, availableColumns = [] } = params
	if (!Array.isArray(filteredRows) || !searchText) return filteredRows

	const term = searchText.toString().toLowerCase().trim()

	// Detect if the input looks like a date/time
	const isDate = moment(
		term,
		[
			'MM/DD/YYYY',
			'YYYY-MM-DD',
			'MM/DD/YYYY hh:mm A',
			'MM/DD/YYYY h:mm A',
			'h:mm A',
			'hh:mm A',
			'HH:mm',
		],
		true
	).isValid()

	const stringifyValue = (value) => {
		if (value == null) return ''

		// Handle moment objects
		if (typeof value === 'object' && value._isAMomentObject) {
			return value.utcOffset(value._offset || 0).format('MM/DD/YYYY h:mm A') || ''
		}

		// Handle native Date
		if (value instanceof Date) {
			return moment(value).format('MM/DD/YYYY h:mm A')
		}

		// Handle arrays or nested objects recursively
		if (typeof value === 'object') {
			return Object.values(value)
				.map((v) => stringifyValue(v))
				.join(' ')
		}

		return String(value)
	}

	return filteredRows.filter((row) => {
		let rowToCheck = availableColumns.length
			? Object.fromEntries(Object.entries(row).filter(([key]) => availableColumns.includes(key)))
			: { ...row }

		let valuesToCheck
		if (isDate) {
			valuesToCheck = Object.fromEntries(
				Object.entries(rowToCheck).filter(
					([key, val]) => val instanceof Date || (typeof val === 'object' && val?._isAMomentObject)
				)
			)
		} else {
			valuesToCheck = Object.fromEntries(
				Object.entries(rowToCheck).filter(
					([key, val]) =>
						!(val instanceof Date) && !(typeof val === 'object' && val?._isAMomentObject)
				)
			)
		}

		const rowText = Object.values(valuesToCheck)
			.map((val) => stringifyValue(val))
			.join(' ')
			.toLowerCase()

		return rowText.includes(term)
	})
}
